export type CountryCode = 'cs' | 'at' | 'ch' | 'de' | 'fr' | 'hu' | 'it' | 'pl' | 'ro' | 'sk';

/** Array of countries not officially deployed to production */
export const notReadyCountries: CountryCode[] = ['ch', 'it']

export const countries: { code: CountryCode, link: string }[] = [
  { code: 'cs', link: 'https://www.mixit.cz' },
  { code: 'at', link: 'https://www.mixit.at' },
  { code: 'ch', link: 'https://www.mixit.ch' },
  { code: 'de', link: 'https://www.mixit.de' },
  { code: 'fr', link: 'https://www.mixit.fr' },
  { code: 'hu', link: 'https://www.mixit.hu' },
  { code: 'it', link: 'https://www.mixit.it' },
  { code: 'pl', link: 'https://www.mixit.pl' },
  { code: 'ro', link: 'https://www.mixit.ro' },
  { code: 'sk', link: 'https://www.mixit.sk' }
];
